import { render, staticRenderFns } from "./BalanceDetail.vue?vue&type=template&id=c2a22ba6&scoped=true&"
import script from "./BalanceDetail.vue?vue&type=script&lang=js&"
export * from "./BalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDetail.vue?vue&type=style&index=0&id=c2a22ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a22ba6",
  null
  
)

export default component.exports